import { getToken, setToken, removeToken } from '@/utils/auth'
import { login, logout } from '@/api/user'
import router from '@/router'
import { Message } from 'element-ui'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
    roles: [],
    permissions: []
  }
  
  const mutations = {
    SET_TOKEN: (state, token) => {
      state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
    }
  }

  const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    const { account, password, captcha, terminalType } = userInfo
    return new Promise((resolve, reject) => {
      // 调用API登录
      login({ account: account.trim(), password, captcha, terminalType })
        .then(response => {
          const { data } = response;
          
          // 保存token
          commit('SET_TOKEN', data.token);
          setToken(data.token);
          
          // 保存用户信息
          if (data.userInfo) {
            commit('SET_NAME', data.userInfo.name);
            commit('SET_AVATAR', data.userInfo.avatar || '');
            
            // 保存用户信息到localStorage
            localStorage.setItem('userInfo', JSON.stringify({
              name: data.userInfo.name,
              avatar: data.userInfo.avatar || '',
              roles: data.roles || ['user']
            }));
          } else if (data.name) {
            commit('SET_NAME', data.name);
            
            // 保存用户信息到localStorage
            localStorage.setItem('userInfo', JSON.stringify({
              name: data.name,
              avatar: '',
              roles: data.roles || ['user']
            }));
          } else {
            // 尝试从其他可能的位置获取用户名
            const possibleName = data.account || account;
            commit('SET_NAME', possibleName);
            
            // 保存用户信息到localStorage
            localStorage.setItem('userInfo', JSON.stringify({
              name: possibleName,
              avatar: '',
              roles: data.roles || ['user']
            }));
          }
          
          // 保存角色和权限
          if (data.roles && data.roles.length > 0) {
            commit('SET_ROLES', data.roles);
          } else {
            commit('SET_ROLES', ['user']); // 默认角色
          }
          
          if (data.permissions && data.permissions.length > 0) {
            commit('SET_PERMISSIONS', data.permissions);
            
            // 保存权限到localStorage
            localStorage.setItem('permissions', JSON.stringify(data.permissions));
          } else {
            commit('SET_PERMISSIONS', []);
            localStorage.removeItem('permissions');
          }
          
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    })
  },

  // 获取用户信息（使用登录时保存的信息）
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 如果没有token，拒绝请求
      if (!state.token) {
        reject(new Error('未登录或登录已过期，请重新登录'));
        return;
      }
      
      try {
        // 尝试从localStorage获取用户信息
        const userInfoStr = localStorage.getItem('userInfo');
        const permissionsStr = localStorage.getItem('permissions');
        
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          console.log('从localStorage获取到用户信息:', userInfo);
          
          // 设置用户信息
          commit('SET_NAME', userInfo.name || '');
          commit('SET_AVATAR', userInfo.avatar || '');
          
          // 设置角色
          const roles = userInfo.roles || ['user'];
          commit('SET_ROLES', roles);
          
          // 设置权限
          let permissions = [];
          if (permissionsStr) {
            permissions = JSON.parse(permissionsStr);
            console.log('从localStorage获取到权限信息:', permissions);
            commit('SET_PERMISSIONS', permissions);
          }
          
          resolve({
            roles,
            name: userInfo.name,
            avatar: userInfo.avatar,
            permissions
          });
        } else if (state.roles && state.roles.length > 0) {
          // 使用已保存的用户信息
          resolve({
            roles: state.roles,
            name: state.name,
            avatar: state.avatar,
            permissions: state.permissions
          });
        } else {
          // 如果没有角色信息，设置默认角色
          const roles = ['user'];
          commit('SET_ROLES', roles);
          
          resolve({
            roles,
            name: state.name,
            avatar: state.avatar,
            permissions: state.permissions
          });
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 如果出错，使用默认角色
        const roles = ['user'];
        commit('SET_ROLES', roles);
        
        resolve({
          roles,
          name: state.name,
          avatar: state.avatar,
          permissions: state.permissions
        });
      }
    })
  },

  // 用户登出
  logout({ commit, state, dispatch }) {
    return new Promise((resolve) => {
      // 调用API登出
      logout()
        .then(() => {
          // 清除token和用户信息
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          commit('SET_PERMISSIONS', []);
          removeToken();
          
          // 清除localStorage中的用户信息和权限
          localStorage.removeItem('userInfo');
          localStorage.removeItem('permissions');
          
          // 重置路由
          dispatch('permission/resetRoutes', null, { root: true });
          
          // 强制刷新页面确保所有状态都被清除
          setTimeout(() => {
            window.location.reload();
          }, 10);
          
          resolve();
        })
        .catch(() => {
          // 即使API调用失败，也清除本地数据
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          commit('SET_PERMISSIONS', []);
          removeToken();
          
          // 清除localStorage中的用户信息和权限
          localStorage.removeItem('userInfo');
          localStorage.removeItem('permissions');
          
          // 重置路由
          dispatch('permission/resetRoutes', null, { root: true });
          
          // 强制刷新页面确保所有状态都被清除
          setTimeout(() => {
            window.location.reload();
          }, 10);
          
          resolve();
        });
    })
  },

  // 前端登出（token失效时调用）
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_PERMISSIONS', []);
      removeToken();
      
      // 清除localStorage中的用户信息和权限
      localStorage.removeItem('userInfo');
      localStorage.removeItem('permissions');
      
      resolve();
    })
    }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }